import React, { useEffect, useRef } from 'react';

const PeerVideo = ({videoStream, mute}) => {
//   const {
//     videoStream,
//     // frameStyle,
//     id,
//     muted,
//     // videoStyles,
//     // videoRef, // Uncomment if you want to use a passed-in ref
//   } = props;

  const videoRef = useRef(null);

  useEffect(() => {
    if (videoStream && videoRef.current) {
      videoRef.current.srcObject = videoStream;
    }
  }, [videoStream]);

  return (
      <video
      id='reusable-video'
        autoPlay
        // style={{ ...videoStyles }}
        ref={videoRef}
        muted={mute}
      />
  );
};
export default PeerVideo;